<template>
  <div class="container-general quotation-container page-break-after">
    <img class="bg" src="../../../images/project-img/letteraQ.svg" alt="" />
    <div class="top-quotation">
      <div class="block-left">
        <h1 class="car_name title">
          <span>
            {{ infocar.nome }}
          </span>
        </h1>
        <div class="car_data text-align-right">
          <div class="title_table row_data">
            <div>Dati veicolo</div>
            <img v-if="vehicle_type==='1'" src="../../../images/project-img/ico-classic-blue.png" alt="" width="80" />
            <img v-else-if="vehicle_type==='2'" src="../../../images/project-img/Ico-veicoli-industriali.svg" alt="" width="80" />
          </div>
          <div class="row_data">
            <div class="data_title">Cilindrata</div>
            <div class="data_content">{{ infocar.cilindrata }}</div>
          </div>
          <div class="row_data">
            <div class="data_title">Immatricolazione</div>
            <div class="data_content">{{ infocar.immatricolazione }}</div>
          </div>
        </div>
      </div>
      <div class="block-right">
        <div class="text-align-center logo-cont-quotation">
          <img
            src="../../../images/project-img/quotazioni-ruoteclassiche-logo.png"
            alt=""
            width="280"
          />
        </div>
        <div class="disclaimer_section">
          <div class="fw-bold title-disclaimer">Quotazione richiesta il {{ infocar.giorno_creazione + ' ' + infocar.mese_creazione + ' ' + infocar.anno_creazione }}.</div>
          Valida solo nel mese solare in corso di elaborazione:
          <span class="fw-bold text-red">{{ infocar.mese_creazione + ' ' + infocar.anno_creazione }}</span>
        </div>
      </div>
    </div>
    <div class="container-real-quotation ">
      <div class="container-real-quotation-row" v-for="(valore, index) in valori" :key="index">
        <div class="title-real-quotation">
          <div>
            {{ valore.sigla }}
          </div>
          <div>{{ formatNumber(valore.valore) }}€</div>
        </div>
        <div class="content-real-quotation">{{ valore.descrizione_corta }}</div>
        <p class="content-quotation-spec">
          {{ valore.descrizione_lunga }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CertificateClassic',
  props: {
    infocar: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    valori: {
      type: Array,
      required: true,
    },
    vehicle_type: {
      type: String,
      required: false,
    },
  },
  methods: {
    formatNumber(value) {
      if (value === null || value === undefined) {
        return '';
      }
      const parts = value.toString().split('.');
      // Format the integer part with dots as thousands separators
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return parts.join('.');
    },
  },
};
</script>

<style scoped>
.quotation-container {
  margin-top: 40px;
  background-color: #e8eaea;
  border-radius: 50px;
  padding: 50px;
  margin-bottom: 30px;
  position: relative;
  overflow: hidden;
}
.quotation-container img.bg {
  position: absolute;
  top: -10%;
  left: -20%;
}
.quotation-container .top-quotation {
  display: flex;
  gap: 50px;
  position: relative;
}
@media (max-width: 768px) {
  .quotation-container .top-quotation {
    flex-direction: column;
  }
}

.quotation-container .block-left {
  width: 55%;
}

@media (max-width: 768px) {
  .quotation-container .block-left {
    width: 100%;
  }
}

.quotation-container .block-right {
  width: 45%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

@media (max-width: 768px) {
  .quotation-container .block-right {
    width: 100%;
  }
}

.quotation-container .logo-cont-quotation {
  margin-bottom: 40px;
}

.quotation-container .title {
  font-family: 'Montserrat', sans-serif;
  font-stretch: 25%;
  font-size: 25px;
  line-height: 2.25rem;
  text-transform: uppercase;
  font-weight: bold;
  color: #111e41;
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 20px;
}

.quotation-container .car_name {
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 10px;
  padding-right: 10px;
  background-color: white;
  border-radius: 10px;

  -webkit-box-flex: 1;
  -ms-flex: 1 0 auto;
  flex: 1 0 auto;
}
.quotation-container .car_name span {
  font-weight: bold;
  display: inline-block;
  width: 100%;
  text-align: center;
}
.quotation-container .car_data .row_data {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  border-bottom: 1px solid #b1b1b1;
  padding: 10px 0;
  font-size: 16px;
  color: #666666;
}

.quotation-container .car_data .row_data.title_table {
  padding: 15px 0;
}

.quotation-container .car_data .row_data.title_table div {
  color: #111e41;
  text-transform: uppercase;
  font-size: 18px;
  font-weight: 700;
}

.quotation-container .car_data .row_data .data_content {
  font-weight: 700;
  color: black;
  text-transform: uppercase;
}

.container-real-quotation {
  border: 1px solid #111e41;
  border-radius: 20px;
  background: #ffffff;
  padding: 40px;
  margin-top: 40px;
}

.container-real-quotation .container-real-quotation-row {
  padding: 30px 0 20px 0;
  border-bottom: 1px dashed #111e41;
}
.container-real-quotation .container-real-quotation-row:first-child {
  padding-top: 0;
}
.container-real-quotation .container-real-quotation-row:last-child {
  border-bottom: 0;
}

.container-real-quotation .container-real-quotation-row .title-real-quotation,
.container-real-quotation .container-real-quotation-row .content-real-quotation {
  color: #111e41;
  position: relative;
}

.container-real-quotation .title-real-quotation {
  font-size: 50px;
  font-weight: 900;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
}
@media (max-width: 768px) {
  .container-real-quotation .title-real-quotation {
    font-size: 36px;
  }
}

.container-real-quotation .content-real-quotation {
  font-size: 20px;
  font-weight: 900;
  margin-bottom: 10px;
}

.container-real-quotation .content-quotation-spec {
  font-size: 14px;
  line-height: 16px;
  position: relative;
}

.container-real-quotation .content-quotation-spec strong {
  font-weight: bold;
}

.container-real-quotation .container-real-quotation-bottom {
  color: #111e41;
  padding-top: 30px;
  border-top: 1px dashed #111e41;
  max-width: 80%;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// resources/js/app/components/CertificateClassic.vue